import { CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanDeactivateComponent {
  canDeactivate(nextUrl?: string): Observable<boolean> | Promise<boolean> | boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanDeactivateComponent> = (
  component,
  _currentRoute,
  _currentState,
  nextState: RouterStateSnapshot,
) => {
  return component.canDeactivate(nextState?.url);
};
